import { useLanguage } from '../i18n';

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-description">
          {t.footer.description}
        </p>
        <div className="footer-bottom">
          <div className="footer-links">
            <a href="https://www.pickthumb.com/privacy" className="footer-link">{t.footer.privacy}</a>
            <span className="footer-separator">·</span>
            <a href="https://www.pickthumb.com/terms" className="footer-link">{t.footer.terms}</a>
          </div>
          <p className="footer-copyright">© {new Date().getFullYear()} pickthumb</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
